/**
 * One-line site embed: inserts an iframe pointing at the hosted Chatgram form.
 * Intended for CDN: chatgram.brandid.app/embed/v1/chatgram-embed-loader.js
 */
(function (): void {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script || typeof script.src !== 'string' || !script.src) return;

  const root = script.src.slice(0, script.src.lastIndexOf('/') + 1);

  const readData = (
    dashed: string,
    camel: string,
  ): string | null => {
    return (
      script.getAttribute(`data-${dashed}`) || script.getAttribute(`data-${camel}`)
    );
  };

  let domainRaw = readData('domain', 'domain');
  if (domainRaw && domainRaw.trim() === '') domainRaw = null;

  let domain = '';
  if (domainRaw != null && domainRaw.trim() !== '') {
    domain = domainRaw.trim();
  } else if (typeof window !== 'undefined') {
    domain = window.location.hostname;
  }

  const height =
    script.getAttribute('data-height') || script.getAttribute('height') || '640px';
  const width =
    script.getAttribute('data-width') || script.getAttribute('width') || '100%';
  const title =
    script.getAttribute('data-title') || script.getAttribute('title') ||
    'Contact us — Chatgram';

  const apiBaseUrl = readData('api-base-url', 'apiBaseUrl');

  const params = new URLSearchParams();
  if (domain.trim()) params.set('domain', domain.trim());
  if (apiBaseUrl && apiBaseUrl.trim())
    params.set('apiBaseUrl', apiBaseUrl.trim());

  const opt = (dashed: string, camel: string, key: string): void => {
    const v = readData(dashed, camel);
    if (v !== null && v !== '') params.set(key, v.trim());
  };

  opt('public-key', 'publicKey', 'publicKey');
  opt('show-name-field', 'showNameField', 'showNameField');
  opt('categories', 'categories', 'categories');
  opt('category-labels', 'categoryLabels', 'categoryLabels');
  opt('theme', 'theme', 'theme');
  opt('accent', 'accent', 'accent');

  // The page hosting the iframe, so the team sees where the visitor is chatting from.
  try {
    params.set('page', window.location.href.slice(0, 1500));
  } catch {
    /* ignore */
  }

  const iframe = document.createElement('iframe');
  iframe.src = `${root}form.html?${params.toString()}`;
  iframe.title = title;
  iframe.loading = 'lazy';
  iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
  iframe.allow = '';
  iframe.style.border = '0';
  iframe.style.width = width;
  iframe.style.height = height;
  iframe.style.display = 'block';

  script.insertAdjacentElement('afterend', iframe);
})();
